import { Accordion } from '@skupreme/shared/ui';
import { BoxSecondaryText } from '@elements/Common';
import { CommonUtility } from '@utility/common';
import { AccordionBodyContainer, BoldText, Row } from './styles';
import { ProductRow } from './ProductRow';
import type { OrderCustomItem } from '@skupreme/api-contracts/core';

type ItemOrderedProps = {
  currency?: string;
  customItems?: OrderCustomItem[];
  items: Array<{
    _id?: string;
    newQty?: number;
    content?: {
      qty?: number;
      unit_price?: number;
    };
  }>;
  total?: number;
};

export function ItemOrdered({
  items,
  total,
  customItems = [],
  currency,
}: ItemOrderedProps) {
  return (
    <Accordion title="Items Ordered" defaultExpanded headingLevel={4}>
      <AccordionBodyContainer>
        <div className="sk:border-b sk:border-solid sk:border-x-0 sk:border-t-0 sk:border-border-subtle">
          {items.map(item => (
            // @ts-expect-error - TS2739: Type '{ item: any; key: any; qty: any; price: any; }' is missing the following p...
            <ProductRow
              item={item}
              key={item._id}
              qty={item.newQty || item.content?.qty}
              price={item.content?.unit_price}
              currency={currency}
            />
          ))}
          {CommonUtility.isValidArray(customItems) && (
            <>
              <BoxSecondaryText>
                Custom Line Item{customItems.length > 1 ? 's' : ''}
              </BoxSecondaryText>
              {customItems.map((item, i) => (
                // @ts-expect-error - TS2739: ProductRow requires unrelated fulfillment props.
                <ProductRow
                  item={item}
                  key={i}
                  qty={item.quantity}
                  price={item.price}
                  hideImage
                  currency={currency}
                />
              ))}
            </>
          )}
        </div>
        <Row className="sk:mt-2">
          <div>Grand Total</div>
          <BoldText className="sk:text-success">
            {CommonUtility.currencyFormat(total, currency)}
          </BoldText>
        </Row>
      </AccordionBodyContainer>
    </Accordion>
  );
}
